<nk-datetime-edit
  #start
  class="nkStartDateTimeEdit"
  [(value)]="startDate"
  (userSelection)="_rangePartChanged($event,'start')"
  [hideTime]="hideTime"
  [showMilliseconds]="showMilliseconds"
  [showSeconds]="showSeconds"
  [showMeridian]="showMeridian"
  [startAt]="startAt?.start"
  [min]="min"
  [max]="max"
  [clamp]="clamp"
  [defaultTime]="defaultTime?.start"
  [dateFilter]="_dateFilterStart"
  [dateClass]="_dateClassStart"
  [disabled]="disabled"
>
</nk-datetime-edit>
<nk-datetime-edit
  #end
  class="nkEndDateTimeEdit"
  [(value)]="endDate"
  (userSelection)="_rangePartChanged($event,'end')"
  [hideTime]="hideTime"
  [showMilliseconds]="showMilliseconds"
  [showSeconds]="showSeconds"
  [showMeridian]="showMeridian"
  [clamp]="clamp"
  [startAt]="startAt?.end"
  [min]="min"
  [max]="max"
  [defaultTime]="defaultTime?.end"
  [dateFilter]="_dateFilterEnd"
  [dateClass]="_dateClassEnd"
  [disabled]="disabled"
>
</nk-datetime-edit>

<div class="nk-range-datetime-footer">
  <ng-content></ng-content>
</div>
